<template>
  <div class="container-fixed subscription">
    <div class="row flex">
      <div class="col-l-5 col-m-10 col-s-12 col-xs-12">
        <h4 class="sr-only">{{ name }}</h4>
        <dl class="list-desc-grid list-desc-grid-left list-desc-semibold">
          <dt>
            {{ $t('internalcatalogue.template_name_label') }}:
            <!-- #S702 -->
          </dt>
          <dd>
            {{ name }}
            <!-- D425 -->
          </dd>

          <dt>
            {{ $t('internalcatalogue.subscription_template_id_label') }}:
            <!-- #S706 -->
          </dt>
          <dd>
            {{ id }}
            <!-- D427 -->
          </dd>

          <dt>
            {{ $t('internalcatalogue.service_portal_label') }}:
            <!-- #S707 -->
          </dt>
          <dd>
            {{ servicePortal }}
            <!-- D428 -->
          </dd>
        </dl>
      </div>

      <div class="col-l-2 col-m-2 col-s-12 col-xs-12 flex-last-l flex-first-s flex-first-xs offset-bottom-2">
        <button
          :id="'btn-book-' + id"
          :disabled="isDisabled"
          :aria-disabled="isDisabled"
          class="btn btn-default pull-right"
          @click="$emit('update:action', { id })"
        >
          {{ $t('internalcatalogue.booking_button_label') }}
          <!-- S709 / I268 -->
        </button>
      </div>

      <div class="col-l-5 col-m-10 col-s-12 col-xs-12">
        <dl class="list-desc-grid list-desc-grid-left list-desc-semibold">
          <dt>
            {{ $t('internalcatalogue.booked_instances_label') }}:
            <!-- #S708 -->
          </dt>
          <dd>
            {{ bookedInstances }} /
            <abbr v-if="maxInstances === null" :title="$t('internalcatalogue.abbr_infinity')">&infin;</abbr>
            <template v-else>{{ maxInstances }}</template>
            <!-- D429 / D430 -->
          </dd>

          <dt>
            {{ $t('internalcatalogue.with_costs_label') }}:
            <!-- #S704 -->
          </dt>
          <dd>
            {{ $t(`internalcatalogue.with_costs_${isWithCosts ? 'true' : 'false'}_information`) }}
            <!-- S705 -->
          </dd>

          <template v-if="promotionTypeId">
            <dt>
              {{ $t('internalcatalogue.promotion_type_label') }}:
              <!-- S776 -->
            </dt>
            <dd>
              <span v-html="$t(`internalcatalogue.${promotionTypeName}_promotion_information`)" />
              <!-- S777 -->
            </dd>
          </template>
        </dl>
      </div>
    </div>

    <div v-if="description" class="offset-top-2">
      <h5 class="thin">
        {{ $t('internalcatalogue.template_description_label') }}
        <!-- #S703 -->
      </h5>
      {{ description }}
      <!-- D426 -->
    </div>

    <div v-if="maxInstancesReached || isExclusionGroupConflict" class="notification offset-top-1" style="margin-bottom: 0">
      <div class="notification-left">
        <div class="icon-frame">
          <VSvgIcon name="information" variant="outlined" size="large" />
        </div>
      </div>
      <div class="notification-content" style="padding-top: 15px; font-size: 18px" role="region" aria-live="polite">
        <h5 class="sr-only">{{ $t('internalcatalogue.notice_label') }}</h5>
        <label :for="'btn-book-' + id">
          <!-- S713 -->
          <template v-if="maxInstancesReached">
            {{ $t('internalcatalogue.max_instances_reached_information') }}
          </template>
          <template v-else>
            {{ $t('internalcatalogue.exclusion_group_conflict_information', { product: excludedBy }) }}
          </template>
        </label>
      </div>
    </div>
    <div v-else-if="isWithCosts || hasMinimumCommitmentPeriod" class="offset-top-3">
      <h5 class="thin">
        {{ $t('internalcatalogue.price_information_headline') }}
        <!-- #S714 -->
      </h5>
      <VPriceDetails :price="price" :promotion-type-optin="false" :texts="{}" style="margin-bottom: -12px" />
    </div>

    <VConfirmation :id="id" v-model="actionModel" :is-busy="isBusy" heading="internalcatalogue.booking_button_label" class="offset-top-1" @confirm="onBook">
      <template #prompt>
        {{ $t('internalcatalogue.booking_prompt') }}
        <!-- #S710 -->
      </template>
      <template #success>
        <h5 class="sr-only">{{ $t('internalcatalogue.confirmation_label') }}</h5>
        {{ $t('internalcatalogue.succeeded_booking_information') }}
        <!-- #S694 -->
      </template>
    </VConfirmation>
    <!--transition name="fade" mode="out-in" appear>
      <div v-if="currentState === CONFIRMATION" key="confirmation" class="notification confirmation offset-top-1" style="margin-bottom: 0">
        <div class="text-center" aria-live="polite">
          <p>
            <strong>

            </strong>
          </p>
          <button type="submit" class="btn btn-brand btn-small" @click="onBook">
            {{ $t('internalcatalogue.confirm_button_label') }}
          </button>
          <button type="button" class="btn btn-small" @click="currentState = null">
            {{ $t('internalcatalogue.cancel_button_label') }}
          </button>
        </div>
      </div>
      <div v-else-if="currentState === BUSY" class="offset-top-3">
        <VSpinner />
      </div>
      <div
        v-else-if="currentState === SUCCESS"
        key="success"
        class="notification notification-dismissible notification-positive offset-top-1"
        style="margin-bottom: 0"
      >
        <VueGlobalEvents @keyup.esc="currentState = null" />
        <button type="button" class="close" @click="currentState = null">
          <span aria-hidden="true">x</span>
          <span class="sr-only">{{ $t('common.close') }}</span>
        </button>
        <div class="notification-left">
          <div class="icon-frame"><i class="icon icon-confirm icon-large"></i></div>
        </div>
        <div class="notification-content" aria-live="polite">

        </div>
      </div>
    </transition-->
  </div>
</template>

<script>
import VConfirmation from '@/components/Confirmation';
import Proxy from '@/proxies/SubstoreInternalCatalogueProxy';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'Subscription',

  components: {
    VSvgIcon,
    VPriceDetails: () => import('@/components/Substore/PriceDetails'),
    VConfirmation,
  },

  inheritAttrs: false,

  props: {
    /**
     * D427: SUB_CATALOGUE3ResponseInfo.AvailableSubscription3.SubscriptionTemplateID
     */
    id: {
      type: String,
      required: true,
    },

    /**
     * D425: SUB_CATALOGUE3ResponseInfo.AvailableSubscription3.TemplateName
     */
    name: {
      type: String,
      required: false,
      default: null,
    },

    /**
     * D426: SUB_CATALOGUE3ResponseInfo.AvailableSubscription3.TemplateDescription
     */
    description: {
      type: String,
      required: false,
      default: null,
    },

    /**
     * D428: SUB_CATALOGUE3ResponseInfo.AvailableSubscription3.ServicePortal
     */
    servicePortal: {
      type: String,
      required: false,
      default: null,
    },

    /**
     * D429: Number of occurences of corresponding template ID in
     * cust_ORD_OverviewResponseInfo.subscriptionOverview.subscriptionBaseInfo
     * .subscriptionTemplateId with cust_ORD_OverviewResponseInfo.subscriptionOverview
     * .subscriptionBaseInfo.subscriptionStatus 2, 3 or 4 in same subscriptionBaseInfo structure
     */
    bookedInstances: {
      type: Number,
      required: true,
    },

    /**
     * D430: SUB_CATALOGUE3ResponseInfo.AvailableSubscription3.MaxInstances
     */
    maxInstances: {
      type: Number,
      required: false,
      default: null,
    },

    /**
     * S713:
     * if SUB_CATALOGUE3ResponseInfo.AvailableSubscription3.ExclusionGroup.SubscriptionTemplateId
     * is already booked
     * (cust_ORD_OverviewResponseInfo.subscriptionOverview.subscriptionBaseInfo.subscriptionStatus
     * is 2, 3 or 4 for corresponding *subscriptionBaseInfo.subscriptionTemplateId)
     */
    isExclusionGroupConflict: {
      type: Boolean,
      required: true,
    },
    excludedBy: {
      type: String,
      required: false,
      default: null,
    },

    /**
     * S777: SUB_CATALOGUE3ResponseInfo.AvailableSubscription3.PromotionType
     * 1: opt-in
     * 2: opt-out
     */
    promotionTypeId: {
      type: Number,
      required: false,
      default: null,
      validator: (value) => [1, 2].indexOf(value) !== -1,
    },

    /**
     * SUB_CATALOGUE3ResponseInfo.AvailableSubscription3.Price
     */
    price: {
      type: Object,
      required: true,
    },

    /**
     * Stores the "global" action, to show only one confirmation dialogue and set all elements to busy / disabled
     */
    action: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    isDisabled() {
      return this.maxInstancesReached || this.isExclusionGroupConflict || this.isBusy;
    },

    isWithCosts() {
      // if #D282, #D285, #D288 or #D290 have a price
      return (
        this.price.priceDisplay ||
        this.price?.promotion?.priceDisplay ||
        this.price?.setupPrice?.priceDisplay ||
        this.price?.promotion?.setupPrice?.priceDisplay
      );
    },

    hasMinimumCommitmentPeriod() {
      if (!this.price) return false;
      return !!(this.price.minimumCommitmentPeriodUnit && this.price.minimumCommitmentPeriodFactor);
    },

    promotionTypeName() {
      switch (this.promotionTypeId) {
        case 1:
          return 'optin';
        case 2:
          return 'optout';
        default:
          return '';
      }
    },

    maxInstancesReached() {
      if (this.maxInstances === null) return false;
      return this.bookedInstances >= this.maxInstances;
    },

    actionModel: {
      get() {
        return this.action;
      },
      set(v) {
        this.$emit('update:action', v);
      },
    },

    isBusy() {
      return this.action?.isBusy;
    },
  },

  methods: {
    async onBook() {
      this.$set(this.action, 'isBusy', true);

      const response = await new Proxy().book(this.id);
      if (response.head.fault !== null) throw new Error(response.head.fault);

      const { subscription } = response.data;
      this.$emit('update', subscription);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.subscription {
  padding: 24px 24px;
  margin-top: 12px;
  margin-bottom: 24px;
  background: #fff;
  border: 1px solid #eee;

  ::v-deep .notification {
    margin-bottom: 0;
  }
}

h5 {
  margin-top: 12px;
  color: $color-gray;
}

@media screen and (min-width: #{$grid-large-min}px) {
  h5 {
    margin-top: 0;
  }
}

.confirmation button {
  margin-right: 6px;
  margin-left: 6px;
}

.list-desc-grid-left {
  margin-top: 0;
  margin-bottom: 0;
}

.list-desc-grid-left > dd {
  padding-right: 12px;
  padding-bottom: 6px;
}

@media screen and (min-width: 800px) {
  .list-desc-grid-left {
    display: flex;
    flex-wrap: wrap;
  }

  .list-desc-grid-left > dt {
    width: 200px;
    padding-bottom: 12px;
  }

  .list-desc-grid-left > dd {
    width: calc(100% - 212px);
    margin-left: 0;
  }
}

@media screen and (max-width: 800px) {
  .list-desc-grid-left > dt {
    padding-bottom: 6px;
    font-weight: 600;
  }

  .list-desc-grid-left > dd {
    padding-bottom: 12px;
  }
}

@media screen and (min-width: 500px) and (max-width: 800px) {
  .list-desc-grid-left {
    display: flex;
    flex-wrap: wrap;
  }

  .list-desc-grid-left > dt {
    width: 200px;
    padding-bottom: 12px;
  }

  .list-desc-grid-left > dd {
    width: calc(100% - 212px);
    margin-left: 6px;
  }
}
</style>
